/*
 * CONNECTED ON LINKEDIN, OR A WAY TO GET THERE (Gabriel, 2026-10-26).
 *
 * contact.linkedin_connected_at comes from LinkedIn's own "accepted your
 * invitation" mail (src/linkedinConnections.js). Set: a green check beside the
 * profile link. Not set: a yellow Connect, on the person card and as "Connect on
 * LinkedIn" in the lead block.
 *
 * NOT SET IS NOT "NOT CONNECTED". An invitation Gabriel accepted sends him no
 * mail, so Connect can land on a profile that already reads "Message". The
 * button opens the profile and LinkedIn says which it is; nothing here claims
 * to know.
 *
 * Where Connect goes: their profile when we have one, else a LinkedIn people
 * search for their name and company — the one link that still lands near them.
 *
 * "ALREADY CONNECTED" (Gabriel, 2026-11-02, after Andreea Florica read "Not
 * connected" the day after their call): the mail cannot see an invitation he
 * accepted, so he says it beside Connect. POST /contacts/:id/linkedin-connected
 * stamps the contact 'hand', dated that day; DELETE undoes only that. An email
 * naming them later replaces the hand mark with its own date.
 */

export function isConnected(contact) {
  return Boolean(contact && contact.linkedin_connected_at);
}

function profileUrl(v) {
  const s = String(v || "").trim();
  if (!s) return null;
  return /^https?:\/\//i.test(s) ? s : `https://${s.replace(/^\/+/, "")}`;
}

/** Where "Connect" opens, or null when there is nobody to look for. */
export function connectHref(contact, company = null) {
  if (!contact) return null;
  const profile = profileUrl(contact.linkedin_url);
  if (profile) return profile;
  const name = [contact.first_name, contact.last_name].map((s) => String(s || "").trim()).filter(Boolean).join(" ");
  if (!name) return null;
  const words = [name, company && company.name ? String(company.name).trim() : ""].filter(Boolean).join(" ");
  return `https://www.linkedin.com/search/results/people/?keywords=${encodeURIComponent(words)}`;
}

/** The check's tooltip: "Connected on LinkedIn since Sep 8, 2026". */
export function connectedTitle(contact) {
  if (!isConnected(contact)) return null;
  const d = new Date(contact.linkedin_connected_at);
  if (Number.isNaN(d.getTime())) return "Connected on LinkedIn";
  const when = d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  if (isHandMarked(contact)) return `Marked connected on LinkedIn by you on ${when}`;
  const how = contact.linkedin_connection_match === "name" ? " (matched by name and company)" : "";
  return `Connected on LinkedIn since ${when}${how}`;
}

/** Said by hand on the record, so the record can unsay it. */
export function isHandMarked(contact) {
  return Boolean(isConnected(contact) && contact.linkedin_connection_match === "hand");
}

/** Mark (on) or undo (off) "Already connected" for one contact. */
export function connectedRequest(contactId, on) {
  return [`/contacts/${contactId}/linkedin-connected`, { method: on ? "POST" : "DELETE" }];
}
